export function BodyTypesByGroupCtrl ($scope, $uibModalInstance, $translate, body_types, group) {
	
	$scope.body_types = body_types;
	$scope.group = group;
  $scope.selectedItems = [];
	
	$scope.cancel = function () {
		$uibModalInstance.dismiss();
	};

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'code',
        header : {
          text: $translate.instant('COMPANY_SPACE.SETTINGS.CODE')
        }
      },
			{
        classes: 'text-left',
        field  : 'description',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_BODY_TYPES')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: false
      },
      select: {
        enabled: true,
        multi  : true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  $scope.onRowClick = function () {
    $scope.selectedItems = $scope.body_types.filter((row) => row.selected);

    $scope.allSelected = ($scope.selectedItems.length == $scope.body_types.length)
  };
	
	$scope.toggleAll = function () {
		$scope.allSelected = !$scope.allSelected;

    angular.forEach($scope.body_types, function (type) {
      type.selected = $scope.allSelected;
    });
    
    $scope.selectedItems = $scope.body_types.filter((row) => row.selected);
	};
	
	$scope.add = function () {
		$uibModalInstance.close($scope.selectedItems);
	};
}
